import ProxyBase from '../../../../core/proxies/ProxyBase'

class Proxy extends ProxyBase {
  getTotalSeperateCompanies(params) {
    return this.get('Library/HeaderSavedPortfolio', params)
  }

  getPortfolioOverview(params) {
    return this.post('PortfolioInsights/Summary/PortfolioOverview', params)
  }
  exportPortfolioOverview(params) {
    return this.post(
      'PortfolioInsights/Summary/PortfolioOverview/Export',
      params,
      {},
      'download',
    )
  }

  getScoreDistribution(params) {
    return this.post(
      'PortfolioInsights/Summary/ScoreDistribution',
      params,
      {},
      undefined,
      true,
    )
  }
  exportScoreDistribution(params) {
    return this.post(
      'PortfolioInsights/Summary/ScoreDistribution/Export',
      params,
      {},
      'download',
    )
  }

  getTopByIndustry(params) {
    return this.post('PortfolioInsights/Summary/TopByIndustry', params)
  }
  getTopByProvince(params) {
    return this.post('PortfolioInsights/Summary/TopByProvince', params)
  }
  getBussinessSize(params) {
    return this.post('PortfolioInsights/Segment/BussinessSize', params)
  }
  getYearOfOperation(params) {
    return this.post('PortfolioInsights/Segment/YearOfOperation', params)
  }
  exportPortfolioSegment(params) {
    return this.post(
      'PortfolioInsights/Summary/PortfolioSegment/Export',
      params,
      {},
      'download',
    )
  }

  getTopHighestPortfolio(params) {
    return this.post(
      'PortfolioInsights/Summary/TopHighestPortFolio',
      params,
      {},
      undefined,
      true,
    )
  }
  getTopHighestIndustry(params) {
    return this.post(
      'PortfolioInsights/Summary/TopHighestIndustry',
      params,
      {},
      undefined,
      true,
    )
  }
  exportTopHighestScore(params) {
    return this.post(
      'PortfolioInsights/Summary/TopHighestScore/Export',
      params,
      {},
      'download',
    )
  }

  getAlertHighlight(params) {
    return this.get('Alert/AlertHightLight', params)
  }
  getCompanyAlerts(params) {
    return this.post('Alert/AlertList', params)
  }
}

export default new Proxy()
